import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/ui';

// <details>/<summary> rather than a JS accordion: it is open-by-keyboard, findable
// by the browser's own in-page search when closed in modern browsers, and needs no
// state. The questions are the ones the permissions actually raise.
// 'offline' is about signal ("does recording work with no coverage"), which is
// a different question from 'offlineSession' ("how long does offline mode last").
// People ask both, and answering only the first is what generated the support
// mail about the seven days.
const QUESTIONS = ['location', 'data', 'delete', 'company', 'offline', 'offlineSession', 'cost'] as const;

export const Faq: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section
            id="faq"
            eyebrow={t('web.faq.eyebrow')}
            title={t('web.faq.title')}
        >
            <div className="faq">
                {QUESTIONS.map((question) => (
                    <details className="faq__item" key={question}>
                        <summary className="faq__q">{t(`web.faq.${question}.q`)}</summary>
                        <p className="faq__a">{t(`web.faq.${question}.a`)}</p>
                    </details>
                ))}
            </div>
        </Section>
    );
};
